const createEventId = (eventName) => {
  const id = globalThis.crypto?.randomUUID?.() ||
    `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${eventName}-${id}`;
};

export const trackMetaEvent = ({
  eventName,
  eventId = createEventId(eventName),
  email,
  phone,
  externalId,
  customData = {},
}) => {
  if (typeof window === "undefined") return null;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "meta_capi_event",
    meta_event_name: eventName,
    meta_event_id: eventId,
    ...customData,
  });

  fetch("/api/meta-capi", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      eventName,
      eventId,
      eventSourceUrl: window.location.href,
      email,
      phone,
      externalId,
      customData,
    }),
    keepalive: true,
  }).catch(() => {
    // Analytics must never interrupt the user's journey.
  });

  return eventId;
};
